
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Button, Popover, Input } from 'element-ui';
import { Editor } from '@tiptap/core';
import { COLOR_SET } from '@/components/tiptap/utils/color';
import MenuButton from '@/components/tiptap/Menu/MenuButton.vue';
import { TipTapEditorContext } from '@/components/tiptap/types';

@Component({
  components: {
    MenuButton,
    [Button.name]: Button,
    [Popover.name]: Popover,
    [Input.name]: Input,
  },
})
export default class MenuHighlightButton extends Vue {
  @Prop({ required: true }) editor: Editor;
  @Prop({ required: true }) editorContext: TipTapEditorContext;

  get isActive() {
    return this.editorContext.state.isActiveHighlight;
  }

  get colorSet() {
    return COLOR_SET;
  }

  private color = '';
  private popoverVisible = false;

  isColorSelected(color: string) {
    return this.editor.isActive('highlight', { color });
  }

  removeColor() {
    this.popoverVisible = false;
    this.editor.chain().focus().unsetHighlight().run();
  }

  confirmColor(color: string) {
    this.popoverVisible = false;
    this.editor.chain().focus().setHighlight({ color }).run();
  }
}
